/** Matches the initial HTML loader, using its inline styles to avoid a blank handoff. */
export function StartupLoader() {
  return (
    <main className="startup-screen">
      <img src="/favicon.svg" width="48" height="48" alt="" />
      <div className="startup-status" role="status" aria-live="polite">
        <span className="startup-spinner" aria-hidden="true" />
        <span>Loading Facet Flow CRM…</span>
      </div>
    </main>
  );
}
